module.exports = __webpack_public_path__ + "static/media/heat.1e11ab42.svg";